import { Box, SxProps } from "@mui/material";
import Paragraph from "components/controls/form/Paragraph";
import dayjs from "dayjs";
import { FunctionComponent, useMemo } from "react";
import farmSo from "stores/farm";
import { getGrowUnitLayerName, getLayerByNumber } from "stores/growUnit/utils/layer";
import taskSo from "stores/task";
import taskDetailSo from "stores/task/taskDetail";
import theme from "styles/theme";
import { Attachment } from "types/Attachment";
import ChipLayerCmp from "../cycles/detail/ChipLayerCmp";
import TaskItem from "../tasks/list/TaskItem";
import ImageCmp from "./ImageCmp";
import cropSo from "stores/library/crop";
import ImageBlobCmp from "./ImageBlobCmp";



interface Props {
    attach: Attachment
    onPhotoClick?: () => void
}

const PhotoCard: FunctionComponent<Props> = ({
    attach,
    onPhotoClick,
}) => {

    // STORE

    // HOOKs

    // HANDLERs
    const handleTaskSelect = (e) => taskDetailSo.open({ task })

    // RENDER
    const growUnit = useMemo(() => farmSo.getGrowUnitByCode(attach.growUnitCode), [attach.growUnitCode])
    const layerName = useMemo(() => getGrowUnitLayerName(growUnit, getLayerByNumber(growUnit, attach.layer?.layerNumber)), [growUnit, attach.layer?.layerNumber])
    const task = useMemo(() => taskSo.getByUuid(attach.taskUuid), [attach.taskUuid])
    const crop = useMemo(() => cropSo.getByUuid(attach.cropUuid), [attach.cropUuid])

    // if no task, return null
    if (!task) return null

    const name = attach.name
    const date = dayjs(attach.createdAt).format("DD/MM/YYYY")
    const haveTrolley = attach.layer?.trolleysPosition != null
    const flex = 10

    return (
        <Box key={attach.id} sx={sxCard}>

            {!!attach.thumbnailTemporaryUrl ? (
                <ImageCmp sx={sxImage}
                    url={attach.thumbnailTemporaryUrl}
                    onClick={onPhotoClick}
                />
            ) : (
                <ImageBlobCmp sx={sxImage}
                    attach={attach}
                    onClick={onPhotoClick}
                />
            )}

            <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>

                <Paragraph flex={flex} title="NAME">
                    <Box sx={sxTitle}>{name}</Box>
                </Paragraph>

                {!!crop && <Paragraph flex={flex} title="CROP">
                    <Box sx={sxTitle}>{crop.name}</Box>
                </Paragraph>}

                <Paragraph flex={flex} title="TASK">
                    <TaskItem sx={{ flex: 1 }} hidePhoto
                        onClick={handleTaskSelect}
                        task={task}
                        editMode={false}
                    />
                </Paragraph>

                <Paragraph flex={flex} title="LAYER">
                    <Box sx={sxRow}>
                        <ChipLayerCmp label={layerName} />
                        <Box sx={sxSubtitle}>GROW UNIT</Box>
                        <Box sx={sxTitle}>{growUnit?.name ?? "--"}</Box>
                        {haveTrolley && <>
                            <Box sx={sxSubtitle}>TROLLEY</Box>
                            <Box sx={sxTitle}>{attach.layer.trolleysPosition}</Box>
                        </>}
                    </Box>
                </Paragraph>

                <Paragraph flex={flex} title="DATE">
                    <Box sx={sxTitle}>{date}</Box>
                </Paragraph>
            </Box>
        </Box>
    )
}

export default PhotoCard

const sxCard: SxProps = {
    display: "flex",
    padding: "16px",
    borderRadius: "10px",
    gap: 2,
    bgcolor: theme.palette.background.card,
}

const sxRow: SxProps = {
    display: "flex",
    alignItems: "baseline",
    gap: "10px",
}

const sxTitle: SxProps = {
    fontSize: 14,
    fontWeight: 500,
}

const sxSubtitle: SxProps = {
    fontSize: 12,
    fontWeight: 400,
    opacity: .8,
}

const sxImage: SxProps = {
    height: 133,
    width: 133,
}
